import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    
    if (this.authService.isAuthenticated()!= null) {  // Vérifie si l'utilisateur est authentifié
      return true;
    } else {
      this.router.navigate(['/']);  // Redirige vers HomeComponent si l'utilisateur n'est pas authentifié
      return false;
    }
  }
}



